import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { ExplorerView } from '@document-explorer/core';
import { DeUiIconComponent, type UiIconName } from './ui-icon.component.js';

const LABELS: Record<ExplorerView, string> = {
  list: 'List view',
  grid: 'Grid view',
  tree: 'Tree view',
};

@Component({
  selector: 'de-view-switcher',
  standalone: true,
  imports: [DeUiIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (views().length > 1) {
      <div class="de-view-switcher" role="group" aria-label="Change view">
        @for (view of views(); track view) {
          <button
            type="button"
            class="de-view-button"
            [attr.aria-pressed]="current() === view"
            [attr.aria-label]="label(view)"
            [attr.title]="label(view)"
            (click)="viewChange.emit(view)"
          >
            <de-ui-icon [name]="iconFor(view)" />
          </button>
        }
      </div>
    }
  `,
})
export class DeViewSwitcherComponent {
  readonly views = input<ExplorerView[]>([]);
  readonly current = input<ExplorerView>('list');
  readonly viewChange = output<ExplorerView>();

  protected label(view: ExplorerView): string {
    return LABELS[view];
  }

  protected iconFor(view: ExplorerView): UiIconName {
    return view;
  }
}
